import { componentName, NotpImageClass } from './NotpImageClass';

customElements.define(componentName, NotpImageClass);

export { NotpImageClass, componentName };
